import { render } from "./AccoutPage.vue?vue&type=template&id=3a85a3a4&scoped=true"
import script from "./AccoutPage.vue?vue&type=script&lang=js"
export * from "./AccoutPage.vue?vue&type=script&lang=js"

import "./AccoutPage.vue?vue&type=style&index=0&id=3a85a3a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a85a3a4"]])

export default __exports__